import classNames from 'classnames';
import React from 'react';

import { GLEBLU } from '@/constants/constants';
import { LOGO_ID } from '@/constants/testIds';

export default function LogoComponent(props: { [x: string]: any; logoSrc: any; classes: any; className: any }) {
  const { logoSrc, classes, className, ...others } = props;
  return <img data-id={LOGO_ID} alt={GLEBLU} {...others} src={logoSrc} className={classNames(classes.logo, className)} />;
}
